export function replaceVideoText(str) {
  const div = document.createElement('div');
  div.innerHTML = str;
  const video = div.querySelector('.video-wrap');
  if (video) {
    video.innerHTML = '';
  }

  return div.innerHTML;
}

export function replaceUsingRegExp(str) {
  return replaceVideoText(str)
    .replace(
      /<span class="sp-parent(.*?)><span class="sp-robot(.*?)<\/span><\/span>/g,
      ''
    )
    .replace(/<script\b[^>]*>[\s\S]*<\/script>/g, '')
    .replace(/\s{2,}/g, '')
    .replace(/[\r\n]/g, '')
    .replace(/<img[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp/g, '&')
    .replace(/&;/g, '&')
    .replace(/<table(.*?)<\/table>/g, '')
    .replace(/<style(.*?)<\/table>/g, '')
    .replace(/表格支持左右滑动/g, '')
    .replace(/<[^>]*[^/]>/gi, '')
    .replace(/>{1,}/g, '')
    .replace(/&gt;/g, '')
    .replace(/_{2,}/g, '');
}
// 按subStr拆,为什么不直接用split？（猜想：防止丢失subStr，保证文章生成语音短句准确。）
const searchSubStr = (str, subStr) => {
  const res = [];
  let restStr = str;
  let pos = restStr.indexOf(subStr);
  while (pos > -1) {
    res.push(restStr.slice(0, pos + 1));
    restStr = restStr.slice(pos + 1);
    pos = restStr.indexOf(subStr);
  }

  if (restStr) {
    res.push(restStr);
  }

  return res;
};

const pushIfValid = (result, value) => {
  if (value) {
    result.push(value);
  }
};

const splitByPunctuation = stringParams => searchSubStr(stringParams, '。')
  .map(item => item.indexOf('；') > -1 ? searchSubStr(item, '；') : item)
  .reduce((result, cur) => {
    if (Array.isArray(cur)) {
      return [...result, ...cur];
    }
    result.push(cur);
    return result;
  }, []);

const splitLongText = text => {
  const limitLength = 800;
  const sliceOffset = 1;
  const chunks = [];
  let restText = text;
  while (restText.length > limitLength) {
    pushIfValid(chunks, restText.slice(0, limitLength - sliceOffset));
    restText = restText.slice(limitLength - sliceOffset);
  }
  return {
    chunks,
    restText,
  };
};

const mergeShortText = (strArr, startIndex) => {
  const limitLength = 800;
  let text = strArr[startIndex];
  let endIndex = startIndex;
  while (
    text.length < limitLength &&
    strArr[endIndex + 1] &&
    strArr[endIndex + 1].length < limitLength
  ) {
    endIndex++;
    text += strArr[endIndex];
  }
  return {
    text,
    endIndex,
  };
};

// 截取片段，尽量实现不破坏语句本身（有可能出现2倍长度）
export function splitStr(stringParams) {
  const result = [];
  const limitLength = 800;
  const strArr = splitByPunctuation(stringParams);
  let i = 0;
  while (i < strArr.length) {
    if (strArr[i].length > limitLength) {
      const { chunks, restText } = splitLongText(strArr[i]);
      result.push(...chunks);
      if (strArr[i + 1]) {
        strArr[i + 1] = restText + strArr[i + 1];
      } else {
        pushIfValid(result, restText);
      }
      i++;
      continue;
    }

    const { text, endIndex } = mergeShortText(strArr, i);
    pushIfValid(result, text);
    i = endIndex + 1;
  }
  return result;
}
